import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from "@material-ui/core";
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import App from './App';
import theme from './theme';

import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-WL34B29",
};

TagManager.initialize(tagManagerArgs);

Sentry.init({
  dsn: "https://d202bc605e2e43f9a9fa41d286ddd872@o1174241.ingest.sentry.io/6270114",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
